import { CalendarPrimeReact } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { GetAmortizacionesPrestamoByIdParamsProps } from "api/Prestamos.service"
import { DATE_YYYY_MM_DD } from "common/components/FilterMenu/constants"
import { formatDate } from "common/utils/utils"
import { Dispatch, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

export const FilterMenu = ({
  serviceQuery,
  prestamoById,
}: {
  serviceQuery: Dispatch<Partial<GetAmortizacionesPrestamoByIdParamsProps>>
  prestamoById?: string
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const initialDate = [
    new Date(prestamoById as string),
    new Date(new Date().getFullYear(), 11, 31),
  ]
  const [dates, setDates] = useState<Date[] | undefined>(initialDate)

  const queryFixer = (
    queryParams: GetAmortizacionesPrestamoByIdParamsProps
  ): GetAmortizacionesPrestamoByIdParamsProps => {
    const amortizacionesPrestamosParams = {
      FechaLowerLimit: queryParams.FechaLowerLimit,
      FechaUpperLimit: queryParams.FechaUpperLimit,
    }
    const fixedQueryParams: GetAmortizacionesPrestamoByIdParamsProps =
      Object.fromEntries(
        Object.entries(amortizacionesPrestamosParams).filter(
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          ([_keys, value]) => value
        )
      )
    return fixedQueryParams
  }

  const query = {
    FechaLowerLimit:
      dates && dates[0] ? formatDate(dates[0], DATE_YYYY_MM_DD) : "",
    FechaUpperLimit:
      dates && dates[1] ? formatDate(dates[1], DATE_YYYY_MM_DD) : "",
  }

  const handleQuery = () => {
    serviceQuery(queryFixer(query))
  }

  useEffect(() => {
    handleQuery()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dates])

  return (
    <div className='mb-1 tw-flex tw-flex-col xl:tw-flex-row tw-justify-between tw-items-center tw-pb-4 tw-pt-6 tw-shadow-3xl tw-rounded-t-xl'>
      <span className='tw-text-nowrap tw-w-auto tw-text-lg tw-font-medium'>
        {t("prestamos.titleAmortizacion")}
      </span>
      <div className='tw-flex tw-w-full tw-justify-center xl:tw-justify-end'>
        <div className='!tw-w-fit tw-flex tw-items-center !tw-flex-row tw-justify-end tw-flex-wrap'>
          <div className='tw-grid tw-gap-1 xl:tw-flex xl:tw-flex-row md:tw-grid-cols-2 tw-justify-between tw-items-center tw-w-fit'>
            <div className='calendar-container tw-relative tw-mr-3 !tw-mx-0 xl:!tw-mr-2'>
              {dates && (
                <FontAwesomeIcon
                  icon={["fal", "calendar-lines"]}
                  className='!tw-absolute tw-text-simple-10 tw-top-2 tw-left-6 tw-h-5 tw-z-10 tw-cursor-pointer tw-pt-0.5'
                />
              )}
              <CalendarPrimeReact
                value={dates}
                selectionMode='range'
                locale={language}
                dateFormat='dd/mm/yy'
                className={`${dates && "calendar-selected"}`}
                onChange={({ value }) => {
                  if (value) {
                    setDates(value as Date[])
                  }
                }}
                readOnlyInput
                showIcon={!dates}
              />

              {dates &&
                dates?.some((date: Date | undefined) => date !== undefined) && (
                  <FontAwesomeIcon
                    icon={["fal", "xmark"]}
                    className='!tw-absolute tw-top-2 tw-right-6 tw-text-simple-10 tw-h-4 tw-w-4 tw-cursor-pointer !tw-pt-1'
                    onClick={() => {
                      setDates(undefined)
                    }}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
